import ProductInfo from "gatsby-theme-dettol/src/components/ProductInfo/ProductInfo"

import "./ProductInfoOverride.scss"

export default ProductInfo